import { Action, createReducer, on } from '@ngrx/store';

import * as ConfirmationActions from './confirmation.actions';
import { ConfirmationMetadata, ConfirmationResult } from './confirmation-metadata';

export const CONFIRMATION_FEATURE_KEY = 'confirmation';

export interface State {
  current: ConfirmationMetadata;
  last: ConfirmationMetadata;
}

export interface ConfirmationPartialState {
  readonly [CONFIRMATION_FEATURE_KEY]: State;
}

export const initialState: State = {
  current: null,
  last: null
};

const confirmationReducer = createReducer(
  initialState,
  on(ConfirmationActions.showConfirmation, (state, { metadata }) => ({
    ...state,
    current: metadata
  })),
  on(ConfirmationActions.confirmationAccepted, (state) => ({
    ...state,
    current: null,
    last: {
      ...state.current,
      result: ConfirmationResult.Accepted
    }
  })),
  on(ConfirmationActions.confirmationRejected, (state) => ({
    ...state,
    current: null,
    last: {
      ...state.current,
      result: ConfirmationResult.Rejected
    }
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return confirmationReducer(state, action);
}
